import React from 'react';

interface TabProps {
  label: string;
  active: boolean;
  onClick: () => void;
  type?: 'default' | 'secondary';
}

const Tab: React.FC<TabProps> = ({
  label,
  active,
  onClick,
  type = 'default',
}) => {
  const baseClasses =
    'py-2.5 px-6 font-semibold text-sm transition-colors duration-200';

  const secondaryClasses = active
    ? 'bg-[#0040C2] text-white'
    : 'bg-[#F8FAFC] text-[#475569]';

  const defaultClasses = active
    ? 'bg-gray-950 text-white'
    : 'hover:bg-gray-200';

  return (
    <button
      className={`${baseClasses} ${
        type === 'secondary'
          ? `text-sm leading-[150%] border border-[#CBD5E1] ${secondaryClasses} first:rounded-l-md last:rounded-r-md`
          : `rounded-md px-8 ${defaultClasses}`
      }`}
      onClick={onClick}
    >
      {label}
    </button>
  );
};

interface TabsProps {
  tabs: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  type?: 'default' | 'secondary';
}

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  type = 'default',
}) => {
  const containerClasses =
    type === 'secondary'
      ? 'flex w-fit rounded-md p-2 bg-[#F8F8F8] space-x-0'
      : 'flex w-fit bg-gray-100 p-1 gap-2 rounded-lg';

  return (
    <div className={containerClasses}>
      {tabs.map((tab) => (
        <Tab
          key={tab}
          label={tab}
          active={tab === activeTab}
          onClick={() => onTabChange(tab)}
          type={type}
        />
      ))}
    </div>
  );
};

export default Tabs;
